import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap, tap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    NO_CHANGE,
} from 'one-state-subject/src/types';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import { format } from 'one-util-date';
import notification from 'antd/lib/notification';

export const enum Types {
    RESCHEDULE_APPOINTMENT_FETCH = "reschedule-appointment-fetch/athena",
}

/**
 * This function will reschedule an appointment
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchRescheduleAppointmentAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, settings: {
            athenaendpoints: {
                rescheduleappointment
            },
            compatible: { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.RESCHEDULE_APPOINTMENT_FETCH),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                const callRescheduleAppointmentAPI = () => {
                    const { appointmentID, newappointmentID, patientID, reschedulereason } = action.payload || {};
                    
                    // Prepare PUT payload
                    const payload: any = {
                        appointmentID: String(appointmentID || ''),
                        newappointmentID: String(newappointmentID || ''),
                        patientID: String(patientID || ''),
                        reschedulereason: reschedulereason || ''
                    };
                    
                    console.log('Reschedule API - Final payload being sent:', payload);
                    
                    let headers = new Headers();
                    headers.append('Content-Type', 'application/json');
                    
                    const responsefromAPI = server.put({
                        headers: headers,
                        path: rescheduleappointment,
                        data: payload
                    })
                        .then((responseRescheduleAppointment: any) => {
                            console.log('API Call - Response success:', responseRescheduleAppointment?.success);
                            return responseRescheduleAppointment;
                        })
                        .catch((rescheduleAppointmentRes: any) => {
                            console.log('API Call - Error caught:', JSON.stringify(rescheduleAppointmentRes, null, 2));
                            log.error(
                                "ccw-gadget,rescheduleappointment-athena",
                                "rescheduleappointment-athena", {
                                    rescheduleAppointmentRes
                                }
                            );
                            let errorbuild: ErrorObject = {
                                source: "RescheduleAppointment",
                                type: "error",
                                status: rescheduleAppointmentRes?.status,
                                erroritems: rescheduleAppointmentRes?.errors,
                                error_date: errorDate,
                                error_time: errorTime
                            };
                            return errorbuild;
                        })
                    
                    log.debug(
                        "ccw-gadget,rescheduleappointment-athena",
                        "rescheduleappointment-athena request and response", {
                            payload,
                            responsefromAPI
                        });
                    return from(responsefromAPI)
                }
                //Calling callRescheduleAppointmentAPI function here
                //the reason is we need to use pipe function.
                return callRescheduleAppointmentAPI().
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            console.log('Epic - Checking conditions:', {
                                hasError: !!responseAfterTransform.error,
                                hasSuccess: !!responseAfterTransform.success,
                                successValue: responseAfterTransform.success
                            });
                            
                            const actions: any = [];
                            if (responseAfterTransform.error) {
                                // Show error notification
                                notification.error({
                                    message: 'Reschedule Appointment Failed',
                                    description: responseAfterTransform.error?.error?.[0]?.display_text || 'An error occurred while rescheduling the appointment.',
                                    duration: 5,
                                });
                                actions.push(addAction(responseAfterTransform.error));
                            } else if (responseAfterTransform.success === true) {
                                log.debug(
                                    "ccw-gadget,rescheduleappointment-athena",
                                    "Reschedule appointment successful", {
                                        response: responseAfterTransform
                                    });
                                // Show success notification
                                notification.success({
                                    message: 'Appointment Rescheduled Successfully',
                                    description: 'The appointment has been rescheduled.',
                                    duration: 3,
                                });
                                
                                // Get patient selected from state or construct from patientID
                                const patientId = action.payload?.patientID || '';
                                const patientsState = state$.value?.patients;
                                const patientSelected = patientsState?.selected || { id: patientId };
                                
                                log.debug(
                                    "ccw-gadget,rescheduleappointment-athena",
                                    "Dispatching set-appointments-success-athena", {
                                        patientSelected
                                    });
                                
                                // Dispatch action to refresh appointments after successful reschedule
                                const dispatchAction = {
                                    type: 'set-appointments-success-athena',
                                    payload: patientSelected
                                };
                                actions.push(dispatchAction);
                            } else {
                                console.log('Epic - Full responseAfterTransform:', responseAfterTransform);
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

